import { InjectionToken, signal } from '@angular/core';

export const MESSAGE_SERVICE_TOKEN = new InjectionToken<BaseMessageService>('MESSAGE_SERVICE_TOKEN');

export interface Message {
  id: number;
  messageKey: string;
}

export class BaseMessageService {
  private nextId = 0;

  readonly errorMessages = signal<Message[]>([]);
  readonly successMessages = signal<Message[]>([]);

  showSuccessMessage(messageKey: string): void {
    const message: Message = { id: this.nextId++, messageKey };
    this.successMessages.update(current => [...current, message]);
    setTimeout(() => {
      this.successMessages.update(current => current.filter(m => m.id !== message.id));
    }, 5500);
  }

  showErrorMessage(messageKey: string): void {
    const message: Message = { id: this.nextId++, messageKey };
    this.errorMessages.update(current => [...current, message]);
    setTimeout(() => {
      this.errorMessages.update(current => current.filter(m => m.id !== message.id));
    }, 5500);
  }
}
